import axios, { RawAxiosRequestHeaders } from 'axios';

interface RequestArgs {
  method?: string;
  data?: Record<string, unknown>;
  url: string;
  userId?: string;
  signal?: AbortSignal;
  headers?: RawAxiosRequestHeaders;
  withCredentials?: boolean;
}

export const requestHandler = async ({
  method = 'get',
  data = {},
  url,
  userId,
  signal,
  headers,
  withCredentials = true,
}: RequestArgs) =>
  axios({
    method,
    url,
    data,
    signal,
    headers: headers || {
      'Content-Type': 'application/json',
      'x-user-id': userId,
    },
    withCredentials,
  });
